import { RootState } from '../store';

export const secondaryRoute = (state: RootState) =>
  state.navbar.secondaryRoute;
export const primaryRoute = (state: RootState) =>
  state.navbar.primaryRoute;
